module.exports = __webpack_public_path__ + "static/media/Athena.8cf8094f.jpg";